/**
 * @name swords
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTMgMTkgNi02IiAvPgogIDxwYXRoIGQ9Ik0xNC41IDE3LjUgMy41ODYgNi41ODZBMiAyIDAgMDEzIDUuMTcyVjNoMi4xNzJhMiAyIDAgMDExLjQxNC41ODZMMTcuNSAxNC41IiAvPgogIDxwYXRoIGQ9Im0xNC44MjggNi4xNzIgMi41ODYtMi41ODZBMiAyIDAgMDExOC44MjggM0gyMXYyLjE3MmEyIDIgMCAwMS0uNTg2IDEuNDE0bC0yLjU4NiAyLjU4NiIgLz4KICA8cGF0aCBkPSJtMTYgMTYgNCA0IiAvPgogIDxwYXRoIGQ9Im0xOSAyMSAyLTIiIC8+CiAgPHBhdGggZD0ibTUgMTQgNCA0IiAvPgogIDxwYXRoIGQ9Im01IDIxLTItMiIgLz4KICA8cGF0aCBkPSJNNy41IDE2LjUgNCAyMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/swords
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Swords: string = `
<svg
  class="lucide lucide-swords"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m13 19 6-6" />
  <path d="M14.5 17.5 3.586 6.586A2 2 0 013 5.172V3h2.172a2 2 0 011.414.586L17.5 14.5" />
  <path d="m14.828 6.172 2.586-2.586A2 2 0 0118.828 3H21v2.172a2 2 0 01-.586 1.414l-2.586 2.586" />
  <path d="m16 16 4 4" />
  <path d="m19 21 2-2" />
  <path d="m5 14 4 4" />
  <path d="m5 21-2-2" />
  <path d="M7.5 16.5 4 20" />
</svg>
`;

export default Swords;
